import { findInSitemap } from '@pm2/api';
import { makeSearchPageDescriptor } from './util.make-search-page-descriptor.js';

function findPageDescriptorByPath(state, path) {
  if (path === state.searchPath) {
    return makeSearchPageDescriptor(path);
  }
  return findInSitemap(
    state.rootDescriptors,
    (it) => it.path === path.replace(/\?(.*)$/, "")
  );
}

export { findPageDescriptorByPath };
//# sourceMappingURL=util.find-page-descriptor-by-path.js.map
